import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import {UserContext} from "@providers/user";
import {getNorthCitiesIds} from "@models/area";
import Badges from "@atoms/badges";
import ConvertPixelToRem from "@helpers/convert.rem";
import {isEmpty} from "@helpers/helpers";
import Icon from "@atoms/icon";
import {handleTypeTitle, handleTitle, handlePropertyFeatures, getPropertyUrl, handlePropertyPrice} from "../helpers/property_helpers";
import ButtonBase from "@atoms/button.base";
import ButtonTransparent from "@atoms/button.transparent";
import PropertyDeleteModal from "../delete_modal";
import PropertyManageModal from "../manage_modal";
import ChevronLeftIcon from '@icons/chevron-left.svg';
import EditIcon from '@icons/edit.svg';
import TrashIcon from '@icons/trash.svg';
import PriceNegotiableIcon from "@icons/price-negotiable.svg";
import PlayWhiteIcon from "@icons/play-white.svg";
import PropertyQuickSaleModal from "../quick_sale_modal";
import {inArray} from "../../../helpers/arrays";

function CardInfo({property, isBadeSaba, handleShowProperty, selectedFiltersDistrict, selectedCityFilter, categories, handleShowNoResult, videoCount}) {
    const [northCitiesIds, setNorthCitiesIds] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showManageModal, setShowManageModal] = useState(false);
    const [quickSaleModal, setQuickSaleModal] = useState(false);
    const userContext = React.useContext(UserContext);
    const authUser = (userContext.check && !isEmpty(userContext.user)) ? userContext.user : null;

    const isMyProperty = (!isEmpty(authUser) && authUser.id === property.user_id && categories !== 'search');
    const pricing = handlePropertyPrice(property, true, northCitiesIds);

    useEffect(() => {
        if (!northCitiesIds.length) {
            getNorthCitiesIds().then(ids => {
                setNorthCitiesIds(ids);
            })
        }
    }, []);

    const quickSaleCities = [3165];
    const showQuickSaleButton = (property.deal_type === "sale" && inArray(property.city_id, quickSaleCities) && (!property.quick_sale_status || property.quick_sale_status === 'default'))

    return (
        <Figcaption>
            <Card className="position-relative d-flex flex-column h-100">

                <a href={getPropertyUrl(property, isBadeSaba)} onClick={(e) => handleShowProperty(e, getPropertyUrl(property, isBadeSaba), ((!isEmpty(property.media) && property.media.length) ? property.media.length : 0))}>
                    <h3 className="cursor-pointer">
                        <Title className="d-flex align-items-center">
                            {
                                (!property.archived) ?
                                    (
                                        (userContext.check && isMyProperty && property.quick_sale_status && property.quick_sale_status !== 'default') ?
                                            (
                                                property.quick_sale_status === 'requested' ?
                                                    <Badges color="dark" outlined className="ml-8">منتظر بررسی</Badges>
                                                    :
                                                    (
                                                        property.quick_sale_status === 'pending' ?
                                                            <Badges color="dark" outlined className="ml-8">درحال بررسی</Badges>
                                                            :
                                                            <Badges color="dark" outlined className="ml-8">پایان پروژه</Badges>
                                                    )
                                            )
                                            :
                                            (
                                                (userContext.check && isMyProperty && property.status === 'pending') ?
                                                    <Badges color="dark" outlined className="ml-8">منتظر تایید</Badges>
                                                    :
                                                    (
                                                        (videoCount > 0) ?
                                                            <Badges color="video" className="ml-8 d-inline-flex align-items-center">
                                                                <Icon width={8} height={8} className="ml-4"><PlayWhiteIcon/></Icon>
                                                                <span>ویدیو</span>
                                                            </Badges>
                                                            :
                                                            (
                                                                (!isEmpty(property.is_empty) && property.is_empty) ?
                                                                    <Badges color="dark" outlined className="ml-8">تخلیه</Badges>
                                                                    : ''
                                                            )
                                                    )
                                            )
                                    )
                                    : ''
                            }

                            <TypeTitle>{handleTypeTitle(property.deal_type, property.type, property.villa_type)}</TypeTitle>
                        </Title>
                        <Address className="text-ellipsis mt-1">{handleTitle(property, false, selectedCityFilter, selectedFiltersDistrict, true)}</Address>
                    </h3>
                </a>

                <Details>{handlePropertyFeatures(property)}</Details>

                <div className="mt-8 mt-md-auto d-flex align-items-end justify-content-between">

                    {
                        (isMyProperty) ?
                            <ActionButtons className="d-none d-md-flex">
                                <a href={"/properties/" + property.id + "/edit"} className="text-secondary d-flex align-items-center">
                                    <Icon width="16" height="16" className="ml-8"><EditIcon/></Icon>
                                    <span>ویرایش</span>
                                </a>

                                <ButtonTransparent onClick={() => setShowDeleteModal(true)} className="mr-24 text-secondary d-flex align-items-center">
                                    <Icon width="16" height="16" className="ml-8"><TrashIcon/></Icon>
                                    <span>حذف</span>
                                </ButtonTransparent>

                                {
                                    showQuickSaleButton ?
                                        <button
                                            type="button"
                                            onClick={() => setQuickSaleModal(true)}
                                            className="btn btn-danger-text btn-sm mr-24 d-flex align-items-center">
                                            <span>درخواست فروش فوری ملک</span>
                                        </button>
                                        : ''
                                }

                            </ActionButtons>
                            : ''
                    }

                    <PriceContainer className="mr-0 mr-md-auto">
                        {
                            (pricing.length) ?
                                pricing.map(({price, label, extraLabel}, key) =>
                                    <React.Fragment>
                                        {
                                            (!isEmpty(price)) ?
                                                <div className="d-flex align-items-center justify-content-start justify-content-lg-end">
                                                    <Price className="h3">{price.num + ' ' + price.unit + ' ' + label}</Price>

                                                    {
                                                        (property.negotiable) ?
                                                            <React.Fragment>
                                                                <Icon
                                                                    data-class="tooltip"
                                                                    data-html={true}
                                                                    data-tip="به دلیل نوسانات بازار، ممکنه قیمت این آگهی تغییر کرده باشه. برای اطلاع از قیمت دقیق، با مشاور این آگهی تماس بگیرید."
                                                                    width={24}
                                                                    height={24}
                                                                    className="mr-8 p-4 rounded-circle price-negotiable-icon rounded-circle">
                                                                    <PriceNegotiableIcon/>
                                                                </Icon>
                                                                <ReactTooltip/>
                                                            </React.Fragment>
                                                            : ''
                                                    }
                                                </div>
                                                : ''
                                        }

                                        {
                                            !isEmpty(extraLabel) ?
                                                <Price className="d-block">{extraLabel}</Price>
                                                : ''
                                        }
                                    </React.Fragment>
                                )

                                : ''
                        }
                    </PriceContainer>

                    {
                        (!isMyProperty) ?
                            <MoreBtnLink className="d-block d-md-none">
                                <a className="d-flex align-items-center bg-success text-secondary" href={getPropertyUrl(property, isBadeSaba)} onClick={(e) => handleShowProperty(e, getPropertyUrl(property, isBadeSaba), ((!isEmpty(property.media) && property.media.length) ? property.media.length : 0))}>
                                    <span>جزئیات</span>
                                    <Icon width="8" height="8" className="mr-1"><ChevronLeftIcon/></Icon>
                                </a>
                            </MoreBtnLink>
                            : ''
                    }
                </div>

                {
                    (isMyProperty) ?
                        <div className="mt-16 d-flex align-items-center d-md-none">
                            <ButtonBase onClick={() => setShowManageModal(true)} variant="outline" block={!showQuickSaleButton} className={(showQuickSaleButton ? 'flex-1' : '')}>مدیریت آگهی</ButtonBase>

                            {
                                showQuickSaleButton ?
                                    <button
                                        type="button"
                                        onClick={() => setQuickSaleModal(true)}
                                        className="btn btn-danger-text mr-8 d-flex align-items-center flex-1">
                                        <span>فروش فوری</span>
                                    </button>
                                    : ''
                            }
                        </div>
                        : ''
                }
            </Card>

            {
                (isMyProperty) ?
                    <>
                        <PropertyDeleteModal
                            property_id={property.id}
                            show={showDeleteModal}
                            setShow={() => setShowDeleteModal(false)}
                            handleShowNoResult={handleShowNoResult}
                            setShowManageModal={setShowManageModal}
                        />

                        <PropertyManageModal
                            property_id={property.id}
                            property_status={property.status}
                            propertyUrl={getPropertyUrl(property)}
                            propertyMediaCount={((!isEmpty(property.media) && property.media.length) ? property.media.length : 0)}
                            handleShowProperty={handleShowProperty}
                            show={showManageModal}
                            setShow={setShowManageModal}
                            setShowDeleteModal={setShowDeleteModal}
                        />

                        <PropertyQuickSaleModal
                            property_id={property.id}
                            show={quickSaleModal}
                            setShow={() => setQuickSaleModal(false)}
                        />
                    </>
                    : ''
            }
        </Figcaption>
    )
}

export default React.memo(CardInfo);

// *********
// styles
// *********

const Figcaption = styled.figcaption`
  width: calc(100% - 520px);
  @media (max-width: ${props => props.theme.screenSmMax}) {
    width: calc(100% - 260px);
  }

  @media (max-width: ${props => props.theme.screenXsMax}) {
    width: 100%;
  }
`;

const Card = styled.div`
  padding-right: 16px;
  padding-left: 24px;

  @media (max-width: ${props => props.theme.screenXsMax}) {
    display: block;
    width: 100%;
    height: auto !important;
    margin-top: 12px;
    margin-right: 0;
    padding: 0;
  }
`;

const Title = styled.div`
  line-height: 1;
`;

const TypeTitle = styled.div`
  font-size: ${props => props.theme.fontSizeBase};
  color: ${props => props.theme.gray400};
  font-weight: 300;
  line-height: 1.35;
`;

export const Address = styled.address`
  font-size: ${ConvertPixelToRem(18)};
  color: ${props => props.theme.black};
  font-weight: normal;
`;

export const Details = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  .details-segment {
    font-size: ${ConvertPixelToRem(14)};
    line-height: 1.8;

    &:after {
      content: '.';
      font-size: ${props => props.theme.fontSizeBase};
      font-weight: 400;
      padding: 0 4px;
      display: inline-block;
      vertical-align: middle;
    }

    &:last-child {
      &:after {
        content: '';
        clear: both;
      }
    }
  }
`;

export const Price = styled.span`
  display: block;

  @media (max-width: ${props => props.theme.screenXsMax}) {
    //display: inline-block !important;
    margin-top: 0;
  }

  &.h3 {
    font-size: ${ConvertPixelToRem(18)};
  }
`;

const ActionButtons = styled.div`
  svg {
    path, g {
      stroke: ${props => props.theme.secondary};
    }
  }
`;

const MoreBtnLink = styled.div`

  a {
    padding: 4px 12px;
    border-radius: 100px;
    line-height: 1.39;

    svg {
      path {
        stroke: ${props => props.theme.secondary};
      }
    }
  }
`;

export const PriceContainer = styled.div`
  margin-top: auto;
  text-align: left;
  line-height: 1.5;

  @media (max-width: ${props => props.theme.screenXsMax}) {
    position: relative;
    text-align: right;
  }

  .price-negotiable-icon {
    &:active, :hover {
      background-color: ${props => props.theme.danger};
    }

    svg {
      path, g {
        stroke: ${props => props.theme.dangerText};
      }
    }
  }
`;